module.exports = __webpack_public_path__ + "img/studio_nav.ac67e826.svg";